import MD5 from './md5';

export type Hash = (data: string) => string;

export const reduceMD5: Hash = (data) => {
  const md5 = MD5(data);
  let result = '';
  for (let i = 0; i < 32; i += 8) {
    const sb = md5.substring(i, i + 8);
    result += `${sb[1]}${sb[3]}${sb[5]}`;
  }
  return result;
};

type GetDeepLinkId = {
  searchId: string;
  productId: string;
  ctaName: string;
};

export const getDeepLinkId = ({ searchId, productId, ctaName }: GetDeepLinkId): string =>
  reduceMD5(`${searchId}-${productId}-${ctaName}`);
